import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterCheckBoxHandler from "./IDataFilterCheckBoxHandler"

export default class DataFilterCheckBoxHandler implements IDataFilterCheckBoxHandler {

    setDescriptorValuesToUrlParams(descriptor: IDataFilterDescriptor, urlParams: URLSearchParams): void {
        const value = descriptor.value as boolean;
        if (value === null || value === undefined) {
            urlParams.delete(descriptor.name);
        } else {
            urlParams.set(descriptor.name, String(value))
        }
    }

    setDescriptorValuesFromUrlParams(descriptor: IDataFilterDescriptor, urlParams: URLSearchParams): void {
        const storeValue = urlParams.get(descriptor.name) || undefined;
        if (storeValue !== null && storeValue !== undefined) {
            descriptor.value = JSON.parse(storeValue);
        }        
    }    
}